var map = {
	"./button-next.png": 9515,
	"./button-print.png": 599,
	"./button-secondary.png": 762,
	"./button-tick.png": 335,
	"./button.png": 4789,
	"./hamburger.png": 1659,
	"./island-error.png": 8657,
	"./patch-form--toggle-open.png": 997,
	"./patch-form--toggle.png": 6463,
	"./progress--complete.png": 3522,
	"./progress--incomplete.png": 1504
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8999;